export default "__VITE_ASSET__XQW1hljr__"